<template>
  <div class="home">
   <div class="drawer-div">
     <div class="search-input">
       <div class="input-block">
         <i class="el-icon-search"></i>
         <input type="text" v-model="keyWord" placeholder="请输入点位、地址" @keydown.enter="getList">
       </div>
       <el-link type="primary" @click="getList({getType:'search'})">搜索</el-link>
     </div>
     <div class="ts-filter">
       <div class="type-item" :class="{active:tsFilter === '梨'}" @click="changeTsFilter('梨')">
         <div class="img-block">
           <img src="../assets/img/tsFilter/l.png" alt="">
         </div>
         <div>梨</div>
       </div>
       <div class="type-item" :class="{active:tsFilter === '葡萄'}" @click="changeTsFilter('葡萄')">
         <div class="img-block">
           <img src="../assets/img/tsFilter/pt.png" alt="">
         </div>
         <div>葡萄</div>
       </div>
       <div class="type-item" :class="{active:tsFilter === '黄桃'}" @click="changeTsFilter('黄桃')">
         <div class="img-block">
           <img src="../assets/img/tsFilter/ht.png" alt="">
         </div>
         <div>黄桃</div>
       </div><div class="type-item" :class="{active:tsFilter === '西瓜'}" @click="changeTsFilter('西瓜')">
       <div class="img-block">
         <img src="../assets/img/tsFilter/xg.png" alt="">
       </div>
       <div>西瓜</div>
     </div>
       <div class="type-item" :class="{active:tsFilter === '火龙果'}" @click="changeTsFilter('火龙果')">
         <div class="img-block">
           <img src="../assets/img/tsFilter/hlg.png" alt="">
         </div>
         <div>火龙果</div>
       </div>
       <div class="type-item" :class="{active:tsFilter === '瓜果蔬菜'}" @click="changeTsFilter('瓜果蔬菜')">
         <div class="img-block">
           <img src="../assets/img/tsFilter/ggsc.png" alt="">
         </div>
         <div>瓜果蔬菜</div>
       </div>
     </div>
     <div class="type-filter">
       <div class="type-item" :class="{active:typeFilter === 'sdd'}" @click="changeTypeFilter('sdd')">
         <div class="img-block">
           <img src="../assets/img/sdd.png" alt="">
         </div>
         <div>疏导点</div>
       </div>
       <div class="type-item" :class="{active:typeFilter === 'gkd'}" @click="changeTypeFilter('gkd')">
         <div class="img-block">
           <img src="../assets/img/gkd.png" alt="">
         </div>
         <div>管控点</div>
       </div>
       <div class="type-item" :class="{active:typeFilter === 'tsd'}">
         <div class="img-block" @click="changeTypeFilter('tsd')">
           <img src="../assets/img/tsd.png" alt="">
         </div>
         <div @click="changeTypeFilter('tsd')">特色点</div>
         <transition name="el-fade-in-linear">
         <div v-if="typeFilter === 'tsd'" class="checkbook-content">
           <el-checkbox-group v-model="checkList" @change="getList">
             <div class="check-item">
               <el-checkbox label="特色集市、夜市" border></el-checkbox>
             </div>
             <div class="check-item">
               <el-checkbox label="外摆位" border></el-checkbox>
             </div>
           </el-checkbox-group>
         </div>
         </transition>
       </div>
     </div>
     <div class="list-block">
       <div class="list-item" v-for="data in itemList" @click="mapToPoint(data)">
         <div class="img-block" v-if="data.content.images && data.content.images.length">
           <img :src="setImages(data.content)" alt="">
         </div>
         <div class="img-block" v-else>
           <img :src="img2" alt="" v-if="data.content.title === '大学路商业街'">
           <img :src="img5" alt="" v-else-if="data.content.title === '迪士尼小镇'">
           <img :src="img6" alt="" v-else-if="data.content.title === '锦江乐园夜市'">
           <img :src="img7" alt="" v-else-if="data.content.title === '首尔夜市景'">
           <img :src="img3" alt="" v-else-if="data.content.title === '外滩源集'">
           <img :src="img4" alt="" v-else-if="data.content.title === '安义路夜巷'">
           <img :src="img1" alt="" v-else-if="data.content.title === 'BFC外滩枫径'">
           <img :src="setImage(data.content.pointTypeName)" alt="" v-else>
         </div>
         <div class="font-block" style="flex: 1">
           <div class="title">
             {{data.content.title}}

           </div>
           <div>
             <span class="tagName-ts" v-if="data.expandData1 === '3'"
                   :class="{y:data.content.pointTypeName === '外摆位',g:data.content.pointTypeName === '特色集市、夜市',x:data.content.pointTypeName === '限时步行街'}">
               {{data.content.pointTypeName}}
             </span>
           </div>
           <div>
             地址：{{data.content.pointAddress}}
           </div>
           <div>
             开放时间：{{data.content.businessTime}}
           </div>
           <div>
             <span class="tagName"
                   :class="{y:item === '梨'||item === '黄桃',r:item === '火龙果',z:item === '葡萄',g:item === '西瓜'||item === '瓜果蔬菜'}"
                   v-for="item in data.tagName">
               {{item}}
             </span>
           </div>
         </div>
         <div @click.stop="toPoint(data.content)" style="margin: auto 10px auto 0">
           <img src="../assets/img/dh.png" style="width: 25px" alt="">
         </div>
       </div>
     </div>
   </div>
    <div class="area-filter">
      <span @click="changeArea('')" class="area-item" :class="{active:areaFilter === ''}">全市</span>
      <span v-for="data in areaArray" @click="changeArea(data)" class="area-item" :class="{active:areaFilter.name === data.name}">
        {{data.name}}
      </span>
    </div>
    <div class="map-content">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import img1 from '@/assets/mockImages/bfc.png'
import img2 from '@/assets/mockImages/daxuelu.png'
import img3 from '@/assets/mockImages/waitan.png'
import img4 from '@/assets/mockImages/anyilu.png'
import img5 from '@/assets/mockImages/dishini.png'
import img6 from '@/assets/mockImages/jinjiang.png'
import img7 from '@/assets/mockImages/shouer.png'
import axios from "axios";
import areaArray from "@/components/areaCode";
import Vue from "vue";
import infoWindowComponent from "./dialog.vue";
import utils from '../common/utils'
const book = {
  "sdd":"1",
  "gkd":"2",
  "tsd":"3",
}
const book1 = {
  "特色集市、夜市":"1",
  "外摆位":"2",
}
export default {
  name: 'Home',
  components: {
    infoWindowComponent
  },
  data(){
    return {
      img1,
      img2,
      img3,
      img4,
      img5,
      img6,
      img7,
      keyWord:"",
      checkList:["特色集市、夜市","外摆位"],
      areaArray,
      tsFilter:"",
      infoWindow:"",
      areaFilter:"",
      typeFilter:"",
      map:null,
      itemList:[],
      direction:true,
      markerLayer:null
    }
  },
  methods:{
    // 设置图片
    setImage(data) {
      return utils.setPointTypeImage(data)
    },
    setImages(data) {
      let imageUrl = ''
      if(data && data.images && data.images[0]?.filePath) {
        imageUrl = window.webConfig.superviseUrl +data.images[0].filePath + '?&width=200'
      }else if(data && data.images && data.images[0]?.content) {
        imageUrl = data.images[0].content
      }else {
        imageUrl = ''
      }
      return imageUrl
    },
    changeArea(data){
      this.areaFilter = data;
      if (data){
        this.map.panTo(new TMap.LatLng(data.center.split(',')[1],data.center.split(',')[0]))
        setTimeout(()=>{
          this.map.zoomTo(12)
        },500)
      }else{
        this.map.panTo([31.115115,121.388375])
        setTimeout(()=>{
          this.map.zoomTo(10)
        },500)
      }

      this.getList()
    },
    toPoint(data){
      window.open("https://uri.amap.com/marker?position="+data.latlng.split(',')[1]+","+data.latlng.split(',')[0])
    },
    mapToPoint(data){
      // 首页点位点击埋点
      utils.setExecute({
        "type": "shangHaiTanExecute",//类型
        "PageId": "ShangHaiTanPointsLists",//页面ID
        "EventType": "pointClick",//事件类型
        "EventName": "点位点击",//事件名称
        ObjId:data.id, // 对象ID
        ObjName:data.title, // 对象名称
        clientType:'screen-PC',
      })
      this.map.panTo(new TMap.LatLng(data.content.latlng.split(',')[0],data.content.latlng.split(',')[1]))
      setTimeout(()=>{
        this.map.zoomTo(16)
      },500)
    },
    showPoints(){

      this.markerLayer = new TMap.MultiMarker({
        map: this.map,  //指定地图容器
        //点标记数据数组
        styles: { //点标注的相关样式
          "sdd-d": new TMap.MarkerStyle({
            "width": 25,
            "height": 30,
            "src": "./sdd-d.png"
          }),
          "gkd-d": new TMap.MarkerStyle({
            "width": 25,
            "height": 30,
            "src": "./gkd-d.png"
          }),
          "tsd-d": new TMap.MarkerStyle({
            "width": 25,
            "height": 30,
            "src": "./tsd-d.png"
          }),
        },
        geometries:this.itemList.map(i=>{
          if(i.content.latlng && i.content.latlng) {
            let res = {
              "position": new TMap.LatLng(i.content.latlng.split(',')[0],i.content.latlng.split(',')[1]),  //点标记坐标位置
              "properties":{...i},
              "styleId": i.expandData1 === "1"?"sdd-d":i.expandData1 === "2"?"gkd-d":"tsd-d",
              "title": i.title
            }
            return res
          }
        })
      });
      this.markerLayer.on("click",(data)=>{
        if (this.infoWindow)this.infoWindow.destroy()
        this.map.panTo(data.latLng)
        this.infoWindow = new TMap.InfoWindow({
          map: this.map,
          position: data.latLng,
          offset: {
            x: 0,
            y: -32
          }, //设置信息窗相对position偏移像素
          // enableCustom: true,
          content: '<div class="ref-card" style="width: 403px;height: 220px;"></div>',
        });
        const DialogContainer = Vue.extend({...infoWindowComponent})
        const dlg = new DialogContainer();
        dlg.detail = data.geometry.properties
        dlg.$mount(document.querySelector(".ref-card"))
        // document.querySelector(".ref-card")amount(infoWindowComponent)
        this.infoWindow.close(); //关闭信息窗
        this.infoWindow.open(); //打开信息窗
        // 首页点位点击埋点
        utils.setExecute({
          "type": "shangHaiTanExecute",//类型
          "PageId": "ShangHaiTanPointsLists",//页面ID
          "EventType": "pointClick",//事件类型
          "EventName": "点位点击",//事件名称
          clientType:'screen-PC',
          ObjId:data.geometry.id, // 对象ID
          ObjName:data.geometry.title, // 对象名称
        })
      })
    },
    changeTsFilter(data){
      if (this.tsFilter === data){
        this.tsFilter = ""
      }else{
        this.tsFilter = data
      }
      this.getList()
    },
    changeTypeFilter(data){
      if (this.typeFilter === data){
        this.typeFilter = ""
      }else{
        this.typeFilter = data
      }
      this.getList()
    },
    // 解码base64
    atobFormat(data,index) {
      let str = ''
      if(data) {
        str = decodeURIComponent(escape(atob(data)))
        return JSON.parse(str)
      }

    },
    getList(data){
      if(data && data.getType) {
        // 只有文字搜索 才埋点
        utils.setExecute({
          "type": "shangHaiTanExecute",//类型
          "PageId": "ShangHaiTanPointsLists",//页面ID
          "EventType": "homeSearch",//事件类型
          "EventName": "首页搜索",//事件名称
          clientType:'screen-PC',
          "remarks":this.keyWord
        })
      }
      this.markerLayer?this.markerLayer.destroy():""
      axios.post(window.webConfig.apiPath + "/GeneralBusiness/GetPageListOut",{
        keyWord: this.keyWord + this.tsFilter, // 点位名称
        expandData4:this.checkList.length === 1 ? book1[this.checkList[0]]:(this.checkList.length === 2?"":"3"),
        expandData1:  this.typeFilter?book[this.typeFilter]:"", // 点位类型 string ’1‘疏导点 2管控点 “3”特色点
        unit: this.areaFilter?this.areaFilter.id:"",// 单位
        type: window.webConfig.typeCode, //type
        "pageSize": 9999,
         expandData6:"2",
        expandData5:"1",
          },
    {
            headers:{
              token:utils.getToken({type:window.webConfig.typeCode}).token,
              timestamp:utils.getToken({type:window.webConfig.typeCode}).timestamp,
            }
          }
      ).then(res=>{
        // .filter(i=>{return this.atobFormat(i.content).latlng})
        this.itemList = res.data.resMap.data.map((i,index)=>{
              let content = this.atobFormat(i.content,index)
              let tagName = content.tagName?content.tagName.split('、'):[]
          return {...i,content:this.atobFormat(i.content),tagName}
        })
        this.showPoints()
      })
    },
  },
  created() {
  },
  mounted() {
    //定义map变量，调用 TMap.Map() 构造函数创建地图
    this.map = new TMap.Map(document.querySelector('.map-content'), {
      center:[31.115115,121.388375],
      zoom: 10.2,   //设置地图缩放级别
    });
    this.getList()
  }
}
</script>
<style lang="less">
.map-content{
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.drawer-div{
  position: fixed;
  top: 0;
  z-index: 1005;
  left: 0;
  width: 380px;
  background: white;
  bottom: 0;
  .search-input{
    padding: 30px 30px 15px 30px;
    display: flex;
    .input-block{
      background: #e0e0e0;
      flex: 1;
      margin-right:10px;
      padding-left: 8px;
      border-radius: 50px;
      input{
        background: transparent;
        height: 30px;
        outline: none;
        border: none;
      }
    }
  }
  .ts-filter{
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;
    color: #666;
    font-size: 14px;
    .type-item{
      flex: 1;
      padding: 5px 0;
      cursor: pointer;
      text-align: center;
      &.active{
        background: #e8e8e8;
      }
      .img-block{
        border-radius: 100px;
        height: 35px;
        img{
          width:30px;
        }
      }
    }
  }
  .type-filter{
    display: flex;
    padding-bottom: 15px;
    justify-content: space-around;
    color: #666;
    box-shadow: 0 10px 10px #c8c8c8;
    .type-item{
      padding: 5px 20px;
      position: relative;
      &.active{
        background: #e8e8e8;
      }

      .checkbook-content{
        position: absolute;
        padding: 15px;
        box-shadow: 0 0 10px #888;
        left: 95px;
        top: -15px;
        background: white;
        border-radius: 4px;
        .check-item{
          margin: 10px;
        }
      }
      .img-block{
        width: 50px;
        height: 50px;
        background: #999;
        border-radius: 100px;
        margin: 5px 0;
        img{
          width:100%;
        }
      }
    }
  }
  .list-block{
    max-height: calc(~'100% - 260px');
    padding: 15px 0;
    overflow: auto;
    font-size: 14px;
    color: #666666;
    .list-item{
      display: flex;
      padding: 10px 0;
      cursor: pointer;
      transition: background .3s;
      border-bottom: 1px solid #e8e8e8;
      &:hover{
        background: #e8e8e8;
      }
      .img-block{
        width: 60px;
        height: 60px;
        background: #f0f0f0;
        border-radius: 100px;
        margin:  auto 5px;
        flex-shrink:0;
        overflow: hidden;
        img{
          height: 100%;
        }
      }
      .font-block{
        padding: 0 10px;
        .title{
          font-weight: bold;
          color: #000;
          font-size: 14px;
        }
        .tagName-ts{
          padding: 0 3px;
          display: inline-block;
          font-size: 12px;
          margin:2px 5px 0 0;
          background: rgb(0,127,255);
          border: 1px solid #007FFF;
          color: #fff;
          border-radius: 10px;
          &.y{
            background: rgb(255,149,0);
            border: 1px solid #FF9500;
          }
          &.g{
            background: rgba(43,217,130);
            border: 1px solid #2BD982;
          }
          &.x{
            background: rgba(49, 113, 234, 1);
            border: 1px solid rgba(49, 113, 234, 1);
          }
        }
        .tagName{
          padding: 0 3px;
          display: inline-block;
          margin:2px 5px 0 0;
          background: rgba(0,127,255,0.1);
          border: 1px solid #007FFF;
          color: #007FFF;
          border-radius: 10px;
          &.y{
            background: rgba(255,149,0,0.1);
            border: 1px solid #FF9500;
            color: #FF9642;
          }
          &.g{
            background: rgba(43,217,130,0.1);
            border: 1px solid #2BD982;
            color: #2BD982;
          }
          &.z{
            background: rgba(123,82,204,0.1);
            border: 1px solid #7B52CC;
            color: #7B52CC;
          }
          &.r{
            background: rgba(255,77,77,0.1);
            border: 1px solid #FF4D4D;
            color: #FF4141;
          }
        }
      }
    }
  }
}

.area-filter{
  position: absolute;
  left: 380px;
  padding: 10px 10px 5px 10px;
  top: 0;
  right: 0;
  font-size: 14px;
  color: #666;
  background: rgba(255,255,255);
  z-index: 1002;
  .area-item{
    margin-right: 5px;
    padding: 0 5px;
    display: inline-block;
    width: 60px;
    text-align: center;
    transition: all .3s;
    border-radius: 10px;
    cursor: pointer;
    &.active{
      background: #007FFF;
      border: 1px solid #007FFF;
      text-shadow: #888 2px 2px 5px;
      color: #ffffff;
    }
  }
}
</style>
